
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"22","stroke":"#141B34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 15v-2","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1 14a7 7 0 1114 0 7 7 0 01-14 0z","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12.5 8.5v-3a4.5 4.5 0 10-9 0v3","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    